import React from "react";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import {
    Col,
    Container,
    Form,
    Row,
    Card,
    ListGroup,
    Breadcrumb,
    Dropdown,
} from "react-bootstrap";
import {
    FaSearch,
    FaFolder,
    FaClipboard,
    FaShare,
    FaEye,
    FaTrashAlt,
} from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
    { field: "id", headerName: "ID", width: 1 },
    { field: "firstName", headerName: "Name", width: 200 },
    { field: "size", headerName: "Size", width: 130 },
    { field: "lastName", headerName: "Last modified", width: 200 },

    {
        field: "action",
        headerName: "Action",
        sortable: false,
        width: 150,
        renderCell: (params) => {
            return (
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <span className="actn_icn">
                        <FaEye title="Preview" />
                    </span>
                    <span className="actn_icn">
                        <FaShare title="Share" />
                    </span>
                    <span className="actn_icn">
                        <FaTrashAlt title="Delete" />
                    </span>
                </div>
            );
        },
    },
];

const rows = [
    {
        id: 1,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 35,
    },
    {
        id: 2,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 42,
    },
    {
        id: 3,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 45,
    },
    {
        id: 4,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 16,
    },
    {
        id: 5,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: null,
    },
    {
        id: 6,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 150,
    },
    {
        id: 7,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 44,
    },
    {
        id: 8,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 36,
    },
    {
        id: 9,
        lastName: "3/9/19, 2:40PM",
        firstName: "file.pdf",
        size: "240kb",
        age: 65,
    },
];

const StudentSubfolderFiles = () => {
    return (
        <div className="dashbrd_pg ">
            <SchoolHeader />
            <div className="fls_cllctn_wrap schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>File Management</h2>
                            <div className="pg_brdcrmb">
                                <Breadcrumb>
                                    <Breadcrumb.Item href="/school-dashboard">
                                        Student Subfolder
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>
                                        UCLA
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                        </div>
                        <div className="srch_fld d-inline-block">
                            <Form.Group
                                className="mb-3 position-relative"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Control
                                    type="text"
                                    placeholder="Search here"
                                />
                                <div className="srch_icn">
                                    <FaSearch />
                                </div>
                                {/* <span className="srch_fltr">
                                    <IoFilter />
                                </span> */}
                                <Dropdown className="srch_fltr">
                                    <Dropdown.Toggle
                                        variant=""
                                        id="dropdown-basic"
                                    >
                                        <IoFilter />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Header>
                                            Filter by
                                        </Dropdown.Header>
                                        <Dropdown.Item href="#">
                                            Name
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                            Date of Birth
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                        </div>
                        <div className="files_fldrs">
                            <Row>
                                <Col md={3}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="fldr_cllctn">
                                                <h6>All Folders</h6>
                                                <div className="fldr_list mt-4">
                                                    <ListGroup variant="flush">
                                                        <ListGroup.Item>
                                                            <div className="fldr_div active">
                                                                <span className="fldr_icn">
                                                                    <FaFolder />
                                                                </span>
                                                                <span className="fldr_txt">
                                                                    UCLA
                                                                </span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <div className="fldr_div">
                                                                <span className="fldr_icn">
                                                                    <FaFolder />
                                                                </span>
                                                                <span className="fldr_txt">
                                                                    APU
                                                                </span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <div className="fldr_div">
                                                                <span className="fldr_icn">
                                                                    <FaFolder />
                                                                </span>
                                                                <span className="fldr_txt">
                                                                    CBN
                                                                </span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <div className="fldr_div">
                                                                <span className="fldr_icn">
                                                                    <FaFolder />
                                                                </span>
                                                                <span className="fldr_txt">
                                                                    COMPTON  COLLEGE
                                                                </span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <div className="fldr_div">
                                                                <span className="fldr_icn">
                                                                    <FaFolder />
                                                                </span>
                                                                <span className="fldr_txt">
                                                                    USC
                                                                </span>
                                                            </div>
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md={9}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="all_files ">
                                                <div className="tbl_hdng d-flex justify-content-between align-items-center mb-4">
                                                    <h5 className="mb-0">
                                                        UCLA
                                                    </h5>
                                                    <div className="shr_btns">
                                                        <a className="btn btn_grey me-2">
                                                            <span>
                                                                <FaClipboard />
                                                            </span>{" "}
                                                            Add to Clipboard
                                                        </a>
                                                        <a className="btn btn_grey">
                                                            <span>
                                                                <FaShare />
                                                            </span>{" "}
                                                            Share
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="docs_tbl">
                                                    <div
                                                        style={{
                                                            height: 400,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <DataGrid
                                                            rows={rows}
                                                            columns={columns}
                                                            pageSize={5}
                                                            rowsPerPageOptions={[
                                                                5,
                                                            ]}
                                                            checkboxSelection
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default StudentSubfolderFiles;
